(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-pairs"] && !Shopify.designMode) return;
  try {
    
  // Load Swiper if not already included
  if (typeof Swiper === "undefined") {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js";
    script.onload = initCarousel;
    document.head.appendChild(script);
  } else {
    initCarousel();
  }

  function initCarousel() {
    const carousel = document.querySelector("[data-carousel]");
    if (!carousel) return;
    
    // Find controls within the carousel element
    const swiperEl = carousel.querySelector(".swiper");
    const nextEl = carousel.querySelector(".swiper-button-next");
    const prevEl = carousel.querySelector(".swiper-button-prev");
    const paginationEl = carousel.querySelector(".swiper-pagination");

    const leftSlides = Array.from(carousel.querySelectorAll(".carousel-left img"));
    const leftHeadlines = Array.from(carousel.querySelectorAll(".carousel-left .left-headline"));

    const swiper = new Swiper(swiperEl, {
      loop: false,
      slidesPerView: 1,
      navigation: {
        nextEl: nextEl, // Reference to the element outside .swiper
        prevEl: prevEl, // Reference to the element outside .swiper
      },
      pagination: {
        el: paginationEl, // Reference to the element outside .swiper
        clickable: true,
      },
      on: {
        slideChange: function () {
          const index = this.activeIndex;
          leftSlides.forEach((img, i) => img.classList.toggle("active", i === index));
          leftHeadlines.forEach((hl, i) => hl.classList.toggle("active", i === index));
        },
      },
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerAteleir = document.getElementById('atelierHeader');
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-collections"] && !Shopify.designMode) return;
  try {
    
(function() {
  const OFFSET = 90; 
  const MOBILE_BREAKPOINT = 1024; 

  function init(wrapper) {
    const items = wrapper.querySelectorAll('.js-sticky-item');

    items.forEach(item => {
      const content = item.querySelector('.js-sticky-content');
      if (!content) return;

      let currentState = "normal"; // "normal", "fixed", "bottom"

      function update() {
        // Only apply effect on mobile
        if (window.innerWidth >= MOBILE_BREAKPOINT) {
          content.classList.remove('is-fixed', 'is-bottom', 'is-hidden');
          return;
        }

        const rect = item.getBoundingClientRect();
        let newState = "normal";

        // Sticky state
        if (rect.top <= 0 && rect.bottom - 10 > OFFSET) {
          newState = "fixed";
        }

        // When content is leaving the viewport
        if (rect.bottom - 90 <= OFFSET) {
          newState = "bottom";
        }

        // Hide completely when section is offscreen
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
          content.classList.add('is-hidden');
        } else {
          content.classList.remove('is-hidden');
        }

        if (newState !== currentState) {
          content.classList.remove('is-fixed', 'is-bottom');

          if (newState === "fixed") content.classList.add('is-fixed');
          if (newState === "bottom") content.classList.add('is-bottom');

          currentState = newState;
        }
      }

      let ticking = false;
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(() => {
            update();
            ticking = false;
          });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.full-collections').forEach(init);
  });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
